import React, { useEffect } from 'react'
import { confirmUserEmail } from '../../../actions/userActions'
import { useDispatch, useSelector } from 'react-redux'
import FormContainer from '../../Form/FormContainer'
import Loader from '../../Loader/Loader'
import SignIn from '../SignIn/SignIn'

const ConfirmEmail = ({ match }) => {
  const dispatch = useDispatch()

  const confirmationCode = match.params.code

  const { loading, error, success, loginInfo } = useSelector(
    (state) => state.userConfirmEmail
  )

  useEffect(() => {
    dispatch(confirmUserEmail(confirmationCode))
  }, [confirmationCode, dispatch, loginInfo])

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <div style={{ minHeight: 'calc(100vh - 215px' }}>
          {loading && <Loader />}
          {error && error !== 'User already active' && (
            <div className="error">{error}</div>
          )}
          {(success || error === 'User already active') && (
            <>
              <h1 className="m-b-16">Email successfully confirmed.</h1>
              <SignIn firstLogin={true} />
            </>
          )}
        </div>
      </FormContainer>
    </div>
  )
}

export default ConfirmEmail
